// Showcase catalogue mirrored from imperialagrooverseas.com — the full pack
// range with its spec content. These are display-only (no price);
// purchasable products come from the admin catalogue via /products.
const PACKS = {
  'GT-15': {
    code: 'GT-15',
    name: 'Golden Taj Rozana Rice',
    category: 'Rozana Rice',
    description: 'Golden Taj Rozana Rice is a quality rice variety developed for everyday cooking. It offers a pleasant taste, soft texture and dependable cooking results for daily family meals.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-18': {
    code: 'GT-18',
    name: 'Golden Taj Premium Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Premium Basmati Rice offers long grains, rich aroma and a delightful taste. Carefully selected and processed, it is ideal for daily meals, pulao and family dining.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-22': {
    code: 'GT-22',
    name: 'Golden Taj Daily Rice',
    category: 'Rozana Rice',
    description: 'Golden Taj Daily Rice provides excellent value with consistent quality and taste. It is perfect for regular home cooking and a variety of traditional dishes.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-33': {
    code: 'GT-33',
    name: 'Golden Taj Family Rice',
    category: 'Rozana Rice',
    description: 'Golden Taj Family Rice is specially selected to meet the needs of modern families. It cooks evenly and delivers satisfying taste and texture in every meal.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-35': {
    code: 'GT-35',
    name: 'Golden Taj Everyday Rice',
    category: 'Rozana Rice',
    description: 'Golden Taj Everyday Rice is a versatile rice variety suitable for daily consumption. It offers excellent cooking performance, soft texture and consistent quality.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-36': {
    code: 'GT-36',
    name: 'Golden Taj Zayka Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Zayka Basmati Rice is carefully selected from premium quality paddy to deliver exceptional aroma, taste and texture. Its long grains and rich fragrance make it an excellent choice for biryani, pulao and everyday meals. The rice cooks beautifully with excellent grain elongation and remains soft and fluffy after cooking.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-45': {
    code: 'GT-45',
    name: 'Golden Taj Premium Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Premium Basmati Rice is known for its superior quality, natural fragrance and excellent cooking performance. It delivers authentic taste and consistency for every occasion.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-50': {
    code: 'GT-50',
    name: 'Golden Taj Swaad Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Swaad Basmati Rice offers delightful aroma, long grains and superior cooking quality. It enhances every meal with its authentic taste and fluffy texture.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-55': {
    code: 'GT-55',
    name: 'Golden Taj Value Rice',
    category: 'Rozana Rice',
    description: 'Golden Taj Value Rice combines affordability with quality. It is carefully processed to provide great taste, freshness and reliable results for everyday meals.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-63': {
    code: 'GT-63',
    name: 'Golden Taj Premium Rozana Rice',
    category: 'Rozana Rice',
    description: 'Golden Taj Premium Rozana Rice is crafted for consumers who seek better quality in their daily meals. It offers superior taste, pleasant aroma and excellent cooking consistency.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-65': {
    code: 'GT-65',
    name: 'Golden Taj Premium Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Premium Basmati Rice features extra-long grains, exceptional aroma and fluffy texture after cooking. It is a perfect choice for biryani, celebrations and special meals.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-66': {
    code: 'GT-66',
    name: 'Golden Taj Darbar Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Darbar Basmati Rice is crafted for consumers seeking premium quality rice with exceptional aroma and superior grain length.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-72': {
    code: 'GT-72',
    name: 'Golden Taj Andaaz Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Andaaz Basmati Rice is known for its long grains, rich aroma and excellent cooking quality. Carefully selected and hygienically packed, it is ideal for preparing delicious biryani, pulao and everyday meals.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-74': {
    code: 'GT-74',
    name: 'Golden Taj Premium Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Premium Basmati Rice delivers superior grain length, authentic fragrance and exceptional taste. It is processed under strict quality standards to ensure consistency in every pack.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-75': {
    code: 'GT-75',
    name: 'Golden Taj Premium Biryani Rice',
    category: 'Biryani Rice',
    description: 'Golden Taj Premium Biryani Rice is specially crafted for biryani lovers. Its fluffy texture, grain separation and aroma make every biryani recipe more delicious and flavorful.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-80': {
    code: 'GT-80',
    name: 'Golden Taj Royal Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Royal Basmati Rice is a premium rice variety offering long grains, delightful aroma and excellent cooking performance. Perfect for family meals and special occasions.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-82': {
    code: 'GT-82',
    name: 'Golden Taj Special Biryani Rice',
    category: 'Biryani Rice',
    description: 'Golden Taj Special Biryani Rice provides excellent grain elongation and rich aroma, making it the preferred choice for preparing authentic biryani and festive dishes.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-83': {
    code: 'GT-83',
    name: 'Golden Taj Rozana Rice',
    category: 'Rozana Rice',
    description: 'Golden Taj Rozana Rice is specially designed for everyday cooking. It offers great taste, soft texture and consistent quality for daily family meals.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-86': {
    code: 'GT-86',
    name: 'Golden Taj Shahi Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Shahi Basmati Rice is a premium rice variety known for its exceptional aroma, long grains and superior cooking quality. Carefully selected from the finest paddy fields, it delivers a rich taste and fluffy texture, making it perfect for biryani, pulao and special family gatherings.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-88': {
    code: 'GT-88',
    name: 'Golden Taj Classic Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Classic Basmati Rice offers the perfect combination of aroma, taste and grain length. Hygienically processed and packed, it ensures consistency and premium quality in every serving.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-90': {
    code: 'GT-90',
    name: 'Golden Taj Daily Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Daily Basmati Rice is specially crafted for everyday meals. Its pleasant aroma, soft texture and reliable cooking performance make it an excellent choice for regular household use.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-91': {
    code: 'GT-91',
    name: 'Golden Taj Premium Biryani Rice',
    category: 'Biryani Rice',
    description: 'Golden Taj Premium Biryani Rice is designed to create authentic and flavorful biryani. The grains remain separate after cooking and absorb spices beautifully, delivering a rich culinary experience.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-95': {
    code: 'GT-95',
    name: 'Golden Taj Special Biryani Rice',
    category: 'Biryani Rice',
    description: 'Golden Taj Special Biryani Rice combines long grain texture, excellent aroma and superior taste. It is ideal for preparing delicious biryani, pulao and festive meals.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'GT-99': {
    code: 'GT-99',
    name: 'Golden Taj Special Basmati Rice',
    category: 'Basmati Rice',
    description: 'Golden Taj Special Basmati Rice delivers premium quality, rich fragrance and excellent grain elongation. It is suitable for both daily meals and special occasions.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-11': {
    code: 'SP-11',
    name: 'Shahi Pakwan Nazrana Premium Basmati Rice',
    category: 'Premium Basmati Rice',
    description: 'Shahi Pakwan Nazrana Premium Basmati Rice offers extra-long grains, rich aroma and authentic taste. Perfect for biryani, pulao and festive family meals.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-15': {
    code: 'SP-15',
    name: 'Shahi Pakwan Salaam Shahi Biryani Rice',
    category: 'Shahi Biryani Rice',
    description: 'Shahi Pakwan Salaam Shahi Biryani Rice delivers long grains, rich aroma and authentic taste for delicious biryani and festive meals.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-22': {
    code: 'SP-22',
    name: 'Shahi Pakwan Nagina Premium Basmati Rice',
    category: 'Premium Basmati Rice',
    description: 'Shahi Pakwan Nagina Premium Basmati Rice is carefully selected to deliver exceptional aroma, fluffy grains and premium quality for every special occasion.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-25': {
    code: 'SP-25',
    name: 'Shahi Pakwan Namaste Premium Basmati Rice',
    category: 'Premium Basmati Rice',
    description: 'Shahi Pakwan Namaste Premium Basmati Rice offers superior quality, authentic aroma and outstanding taste for every special meal.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-33': {
    code: 'SP-33',
    name: 'Shahi Pakwan Zannat Premium Basmati Rice',
    category: 'Premium Basmati Rice',
    description: 'Shahi Pakwan Zannat Premium Basmati Rice is known for its long grains, delightful fragrance and superior cooking performance.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-35': {
    code: 'SP-35',
    name: 'Shahi Pakwan Tamanna Shahi Biryani Rice',
    category: 'Shahi Biryani Rice',
    description: 'Shahi Pakwan Tamanna Shahi Biryani Rice is specially crafted for aromatic biryani with extra-long grains and rich flavour.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-41': {
    code: 'SP-41',
    name: 'Shahi Pakwan Jalwa Rozana Rice',
    category: 'Rozana Rice',
    description: 'Shahi Pakwan Jalwa Rozana Rice is a quality daily-use rice offering delicious taste, soft texture and excellent value.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-44': {
    code: 'SP-44',
    name: 'Shahi Pakwan Sahib Premium Basmati Rice',
    category: 'Premium Basmati Rice',
    description: 'Shahi Pakwan Sahib Premium Basmati Rice provides rich aroma, extra-long grains and delicious taste for traditional and modern recipes.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-45': {
    code: 'SP-45',
    name: 'Shahi Pakwan Sikandar Shahi Biryani Rice',
    category: 'Shahi Biryani Rice',
    description: 'Shahi Pakwan Sikandar Shahi Biryani Rice provides perfect grain separation, delicious aroma and authentic biryani experience.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-55': {
    code: 'SP-55',
    name: 'Shahi Pakwan Maharaj Premium Basmati Rice',
    category: 'Premium Basmati Rice',
    description: 'Shahi Pakwan Maharaj Premium Basmati Rice is specially processed for premium quality, fluffy texture and authentic flavour.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-65': {
    code: 'SP-65',
    name: 'Shahi Pakwan Afsana Shahi Biryani Rice',
    category: 'Shahi Biryani Rice',
    description: 'Shahi Pakwan Afsana Shahi Biryani Rice is developed for flavourful biryani with premium quality grains and exceptional aroma.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-66': {
    code: 'SP-66',
    name: 'Shahi Pakwan Kashish Premium Basmati Rice',
    category: 'Premium Basmati Rice',
    description: 'Shahi Pakwan Kashish Premium Basmati Rice combines natural aroma, long grains and excellent cooking quality for every celebration.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-71': {
    code: 'SP-71',
    name: 'Shahi Pakwan Tarana Rozana Rice',
    category: 'Rozana Rice',
    description: 'Shahi Pakwan Tarana Rozana Rice is perfect for everyday meals with consistent quality and satisfying taste.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-77': {
    code: 'SP-77',
    name: 'Shahi Pakwan Chandni Premium Basmati Rice',
    category: 'Premium Basmati Rice',
    description: 'Shahi Pakwan Chandni Premium Basmati Rice delivers elegant presentation, fluffy texture and unforgettable taste.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-81': {
    code: 'SP-81',
    name: 'Shahi Pakwan Mahira Rozana Rice',
    category: 'Rozana Rice',
    description: 'Shahi Pakwan Mahira Rozana Rice is carefully selected to deliver soft texture, pleasant aroma and reliable cooking results.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-88': {
    code: 'SP-88',
    name: 'Shahi Pakwan Nutan Premium Basmati Rice',
    category: 'Premium Basmati Rice',
    description: 'Shahi Pakwan Nutan Premium Basmati Rice offers premium quality, natural fragrance and perfectly separated grains after cooking.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-91': {
    code: 'SP-91',
    name: 'Shahi Pakwan Sugandh Rozana Rice',
    category: 'Rozana Rice',
    description: 'Shahi Pakwan Sugandh Rozana Rice is an ideal daily-use rice with natural aroma, fluffy texture and wholesome taste.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
  'SP-99': {
    code: 'SP-99',
    name: 'Shahi Pakwan Sahil Premium Basmati Rice',
    category: 'Premium Basmati Rice',
    description: 'Shahi Pakwan Sahil Premium Basmati Rice is crafted for superior taste, rich aroma and excellent cooking consistency.',
    sections: [
      {
        label: 'Key Features',
        items: [
          { icon: 'fa-award', text: 'Premium Quality Rice' },
          { icon: 'fa-seedling', text: 'Long Grain Texture' },
          { icon: 'fa-wind', text: 'Rich Natural Aroma' },
          { icon: 'fa-ruler-combined', text: 'Excellent Grain Elongation' },
          { icon: 'fa-check-circle', text: 'Soft & Non-Sticky Texture' },
          { icon: 'fa-utensils', text: 'Ideal For Biryani & Pulao' },
        ],
      },
      {
        label: 'Best For',
        items: [
          { icon: 'fa-home', text: 'Daily Meals' },
          { icon: 'fa-bowl-food', text: 'Biryani' },
          { icon: 'fa-plate-wheat', text: 'Pulao' },
          { icon: 'fa-store', text: 'Restaurants' },
          { icon: 'fa-truck', text: 'Catering Services' },
        ],
      },
    ],
    packing: ['1 Kg', '5 Kg', '10 Kg', '25 Kg'],
  },
};

export default PACKS;
export const packByCode = (code) => PACKS[String(code || '').toUpperCase()] || null;
